import { lazy } from 'react';
import retry from '../../../utils/webpack/chunkRetry';
const ModuleLoaderLazy = lazy(()=>retry(()=>import(/* webpackChunkName: "notes_drawer_redux" */ './ModuleLoader')));
export default ModuleLoaderLazy;
